import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IUser } from "../model/User.model";
import { map, take, switchMap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AngularFireAuth } from "@angular/fire/auth";
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from "@angular/fire/firestore";
import { ICustomer } from "src/app/register/model/customer.model";
import { fromPromiseToObservable } from "../utils";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    private httpClient: HttpClient,
    public afAuth: AngularFireAuth,
    public af: AngularFirestore
  ) {}

  async updateCustomer(customer: ICustomer) {
    const ref = this.af.doc<ICustomer>(`users/${customer.uid}`);
    await ref.update(customer);
  }

  updateCustomerUser(customer: ICustomer) {
    const classRef = this.af.collection("users");
    console.log("customer", customer);
    return fromPromiseToObservable(classRef.doc(customer.uid).update(customer));
  }

  createUser(user: IUser): Observable<any> {
    return this.httpClient
      .post(`${environment.userApiBaseUrl}/addUser`, user)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Create user login user.
  createCustomerUser(customer: ICustomer, password: string): Observable<any> {
    const email = customer.email;
    customer.isAdmin = false;
    customer.isStaff = false;
    customer.isCustomer = true;
    customer.created = Date.now().toString();
    customer.created = Date.now().toString();

    return fromPromiseToObservable(
      this.afAuth.auth.createUserWithEmailAndPassword(email, password)
    ).pipe(
      map((user) => user),
      switchMap((user) => {
        // console.log('createCustomerUser', user);
        const userRef: AngularFirestoreDocument<any> = this.af.doc(
          `users/${user.user.uid}`
        );
        return fromPromiseToObservable(userRef.set(customer, { merge: true }));
      })
    );
  }

  deleteUser(user: IUser): Observable<any> {
    return this.httpClient
      .post(`${environment.userApiBaseUrl}/delUser`, user)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getUserByFieldAndValue(
    fieldName: string,
    fieldValue: string,
    excludeId = null
  ) {
    return this.af
      .collection<IUser>("users", (ref) =>
        ref.where(fieldName, "==", fieldValue)
      )
      .snapshotChanges()
      .pipe(
        map((rows) => {
          const items: any[] = rows.filter((row) => {
            return row.payload.doc.id !== excludeId;
          });

          return items.map((row) => {
            const data = row.payload.doc.data();
            data.id = row.payload.doc.id;
            return data;
          });
        }),
        take(1)
      );
  }

  // Valide User code.
  async validateUserCode(code: string) {
    return await this.httpClient
      .get(`${environment.userApiBaseUrl}/user/${code}`)
      .toPromise();
  }
}
